import './style.css'
export default function Loading(){
    return(
        <div id="loading">
            <p>
                {/* Veuillez patienter */}
            </p>
        </div>
    )
}